<template lang="pug">
    .container
        .row.careers(style="margin-top: 60px")
            .col-md-12
                h5(style="color:#0070a4")   Country - Opening 1
                div Location:
                div Date Published:
                div Annual Income:
                div Type of position:
                div Area:
                hr
                .detail-blue Position's Objective
                .detail-blue Description
                .detail-blue Requirements
                div Education
                div Experience
                div Lenguage
                div Certifications
                div Software Knowledge / Experience
                div Traveling
                router-link.detalle-btn(:to="lang == 'EN' ? '/en/careers' : '/es/oportunidades'") BACK
</template>

<script>
export default {
    props: ['lang']
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmJobDetail.vue